import { render, staticRenderFns } from "./AnswerSlide.vue?vue&type=template&id=7962b2ba"
import script from "./AnswerSlide.vue?vue&type=script&lang=js"
export * from "./AnswerSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7962b2ba')) {
      api.createRecord('7962b2ba', component.options)
    } else {
      api.reload('7962b2ba', component.options)
    }
    module.hot.accept("./AnswerSlide.vue?vue&type=template&id=7962b2ba", function () {
      api.rerender('7962b2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/AnswerSlide.vue"
export default component.exports